<button matTooltipPosition="above" data-dismiss="modal" (click)="closeDialog()" class="viewImg-close-btn">
  <span class="material-icons relative">clear</span>
</button>
<div class="formImg-wrapper">
  <img [src]="imageUrl ?? ' '" alt="vault form image" [style.padding]="'40px'" />
</div>
